import comp from '../components/barrel';
import U from '../js/utils';

/** Associate Advisor — marketer dropdown replaced by advisor autosuggest (View user profile). */
const ASSOCIATE_ADVISOR_ROLE_UUID = 'e7f7fedc-3ebc-4718-968c-3ae91d523ee8';
const NIL_UUID = '00000000-0000-0000-0000-000000000000';

export default {
  async prepare() {
    this.target_user_uuid = thsPage.vars.target_user_uuid;

    const vars = {};
    vars.target_user_uuid = this.target_user_uuid;

    this.recipe.methods.push(await O.mPOST('communal/languages'));
    this.recipe.methods.push(await O.mPOST('communal/provinces'));
    this.recipe.methods.push(await O.mPOST('communal/marketer_for_advisor', vars));
    this.recipe.methods.push(await O.mPOST('users/get-advisor-list'));
    this.recipe.methods.push(await O.mPOST('users/get-user-details', vars));
    this.recipe.methods.push(await O.mPOST('communal/roles'));
    this.recipe.methods.push(await O.mPOST('communal/titles'));
    this.recipe.methods.push(await O.mPOST('communal/div-branches'));
    this.recipe.methods.push(await O.mPOST('communal/org-branches'));
    this.recipe.methods.push(await O.mPOST('communal/divisions'));
  },

  async render() {
    const rec = this.recipe.methods;

    let data = {};

    if (rec.length) {
      data = await O.PREP(rec);
    }

    await this.loadPage(data);
  },

  async loadPage(res) {
    // List of title uuids & title texts used to populate select input options
    this.titleData = res['communal/titles'].data;
    this.roleData = res['communal/roles'].data;
    this.divBranchesData = res['communal/div-branches'].data;
    this.orgBranchesData = res['communal/org-branches'].data;
    this.advisorList = res['users/get-advisor-list'].data;
    this.marketersData = res['communal/marketer_for_advisor'].data;
    this.divisionsData = res['communal/divisions'].data.divisions;
    this.userDetails = res['users/get-user-details'].data;

    const userForm = U.id('user-form');
    userForm.innerHTML = '';

    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');
    grid1.id = 'newUser';

    const vars = {};
    vars.target_user_uuid = this.userDetails.advisor_uuid;

    // // ================================================
    // const mainDiv = U.divAtt('div', 'id', 'mainDiv');

    // // OFFICE DETAILS
    // const officeHeading = U.divAtt('h6', 'class', 'mt-3');
    // officeHeading.innerHTML = 'Office detail: ';
    // grid1.appendChild(officeHeading);

    // const gridOD = U.divAtt('div', 'class', 'res-grid-cols-3');
    // let nameText = comp.displayText('role_display', this.userDetails.role_text, 'Role');
    // // const roleDD = await comp.select_v2({elID: 'roleSelect', ddData: this.roleData, valueDataName: 'role_uuid', textDataName: 'short_text', labelName: 'Role', requiredYN: 1, onchange: 'thsTab.configForm()'});
    // // gridOD.appendChild(roleDD);
    // gridOD.appendChild(nameText);
    // grid1.appendChild(gridOD);
    // grid1.appendChild(mainDiv);

    userForm.appendChild(grid1);
    await this.configForm(this.userDetails.role_text);
  },

  async buildMainPage({pdfWillOnly}) {
    // const userForm = U.id('user-form');
    // userForm.innerHTML = '';

    // const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');
    // grid1.id = 'newUser';

    const mainDiv = U.divAtt('div', 'id', 'mainDiv');
    // const newUser = U.id('mainDiv');
    mainDiv.innerHTML = '';

    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');

    // userForm.appendChild(grid1);
    // await this.configForm(this.userDetails.role_text);
    // ========================================================

    // const newUser = U.id('mainDiv');
    // newUser.innerHTML = '';

    // const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');

    const pdfWillOnlyTgle = await comp.toggle_v2({elID: 'pdfWillOnly', isChecked: this.userDetails.pdf_will_only, labelName: 'PDF will only'});
    !pdfWillOnly && pdfWillOnlyTgle.classList.add('hide');
    const autofillIdTgle = await comp.toggle_v2({elID: 'autofillIdYn', isChecked: this.userDetails.autofill_id_yn, labelName: 'ID autofill'});

    const companyDiv = U.divAtt('div', 'id', 'companyDiv');
    const advisorDiv = U.divAtt('div', 'id', 'advisorDiv');
    const supportDiv = U.divAtt('div', 'id', 'supportDiv');

    // ================================================
    const gridPD = U.divAtt('div', 'class', 'res-grid-cols-3');
    const titleDD = await comp.select_v2({elID: 'title', ddData: this.titleData, valueDataName: 'title_uuid', textDataName: 'short_text', labelName: 'Title', requiredYN: 1, initValue: this.userDetails.title_uuid});
    const f_name = await comp.inputText(`f_name`, this.userDetails.f_name, 'Full names', 1);
    const s_name = await comp.inputText(`s_name`, this.userDetails.s_name, 'Surname', 1);
    const idNum = await comp.inputIDPassport('IDpass', true, this.userDetails.id_nr, 1, 'dob');
    const passNum = await comp.inputIDPassport('IDpass', false, this.userDetails.passport_nr, 1, 'dob');
    const IDpass = this.userDetails.passport_nr ? passNum : idNum;
    const emailInput = await comp.inputEmail('email_address', this.userDetails.email_address, 'Email', 1);
    const mobInput = await comp.inputTel('cell_nr', this.userDetails.cell_nr, 'Mobile number', 1);
    const textarera = await comp.textarea('textarea', this.userDetails.notes, 'Notes', 0);
    const inputPass = await comp.inputPassword({elID: 'password_fake_userdetails', onclick: 'thsTab.updatePassword()'});
    const activeYN = await comp.toggle_v2({elID: 'activeYN', isChecked: this.userDetails.active_yn, labelName: 'Active', onToggleChange: 'thsTab.onActiveYNToggle()'});
    this.restructureActiveToggleStacked(activeYN);
    // ================================================
    // Role row: Role (left), PDF will only (centre when shown), ID autofill, Broker number (right) for Advisor roles
    const isAdvisorRole = this.userDetails.role_text === 'Advisor' || this.userDetails.role_text === 'Associate Advisor';
    const gridOD = U.divAtt('div', 'class', isAdvisorRole ? 'res-grid-cols-4' : 'res-grid-cols-3');
    let nameText = comp.displayText('role_display', this.userDetails.role_text, 'Role');
    gridOD.appendChild(nameText);
    gridOD.appendChild(pdfWillOnlyTgle);
    gridOD.appendChild(autofillIdTgle);
    if (isAdvisorRole) {
      const brokerCol = U.divAtt('div', 'class', 'flex justify-end items-start');
      const brokerNumber = await comp.inputText('brokerNumber', this.userDetails.broker_number, 'Broker Number', 1);
      brokerCol.appendChild(brokerNumber);
      gridOD.appendChild(brokerCol);
    }
    grid1.appendChild(mainDiv);
    // ===========================
    gridPD.appendChild(titleDD);
    gridPD.appendChild(f_name);
    gridPD.appendChild(s_name);
    gridPD.appendChild(IDpass);
    gridPD.appendChild(emailInput);
    gridPD.appendChild(mobInput);
    gridPD.appendChild(textarera);
    const passActiveRow = U.divAtt('div', 'class', 'res-grid-cols-2');
    passActiveRow.appendChild(inputPass);
    passActiveRow.appendChild(activeYN);
    gridPD.appendChild(passActiveRow);
    grid1.appendChild(gridPD);
    // Appending Office Detail & Personal Detail
    grid1.appendChild(gridOD);
    // Broker number & marketer if advisor is being viewed
    grid1.appendChild(companyDiv);
    grid1.appendChild(advisorDiv);
    grid1.appendChild(supportDiv);

    U.id('newUser').appendChild(grid1);

    // // ================================================
    // // OFFICE DETAILS
    // const officeHeading = U.divAtt('h6', 'class', 'mt-3');
    // officeHeading.innerHTML = 'Office detail: ';
    // grid1.appendChild(officeHeading);

    // const gridOD = U.divAtt('div', 'class', 'res-grid-cols-3');
    // let nameText = comp.displayText('role_display', this.userDetails.role_text, 'Role');
    // gridOD.appendChild(nameText);
    // grid1.appendChild(gridOD);
    // grid1.appendChild(mainDiv);
  },

  /**
   * Match Password column: label row, then control row (toggle aligns with password input).
   */
  restructureActiveToggleStacked(activeRoot) {
    const elId = 'activeYN';
    const switchLabel = activeRoot.querySelector('label.switch');
    const textLabel = activeRoot.querySelector(`#${elId}_label`);
    if (textLabel) textLabel.remove();
    if (!switchLabel) return;

    while (activeRoot.firstChild) activeRoot.removeChild(activeRoot.firstChild);

    activeRoot.className = 'input-group w-full';

    const titleLbl = document.createElement('label');
    titleLbl.setAttribute('for', elId);
    titleLbl.textContent = 'Active';

    const toggleRow = document.createElement('div');
    toggleRow.className = 'mt-1 mb-5 flex items-center';
    toggleRow.style.minHeight = '2.75rem';
    switchLabel.style.margin = '0';
    toggleRow.appendChild(switchLabel);

    activeRoot.appendChild(titleLbl);
    activeRoot.appendChild(toggleRow);
  },

  async buildCompanySection() {
    const grid1 = U.id('companyDiv');
    grid1.innerHTML = '';
    // ================================================
    // COMPANY EMPLOYEE
    const companyHeading = U.divAtt('h6', 'class', 'mt-3');
    companyHeading.innerHTML = 'Office Employee: ';
    grid1.appendChild(companyHeading);

    const gridOE = U.divAtt('div', 'class', 'res-grid-cols-2');
    const divBranch = U.divAtt('div', 'id', 'divBranch');
    const divisionDD = await comp.select_v2({elID: 'companyDD', ddData: this.divisionsData, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsTab.showCompanyBranch()', initValue: this.userDetails.division_uuid});
    gridOE.appendChild(divisionDD);
    gridOE.appendChild(divBranch);
    grid1.appendChild(gridOE);
    this.showCompanyBranch();
  },

  async showCompanyBranch() {
    const companyDD = U.id('companyDD').value;
    const grid1 = U.id('divBranch');
    grid1.innerHTML = '';

    if (!companyDD) {
      return;
    }

    const filteredData = this.divBranchesData.filter((division) => division.division_uuid === companyDD);

    const compBranchDD = await comp.select_v2({elID: 'compBranchDD', ddData: filteredData, valueDataName: 'division_branch_uuid', textDataName: 'short_text', labelName: 'Employee company branch', requiredYN: 1});
    grid1.appendChild(compBranchDD);
  },

  async buildCompanySectionPlus() {
    const grid1 = U.id('companyDiv');
    grid1.innerHTML = '';
    // ================================================
    // COMPANY EMPLOYEE
    const companyHeading = U.divAtt('h6', 'class', 'mt-3');
    companyHeading.innerHTML = 'Office Employee: ';
    grid1.appendChild(companyHeading);

    const gridOE = U.divAtt('div', 'class', 'res-grid-cols-2');
    const gridOS = U.divAtt('div', 'class', 'res-grid-cols-2');
    gridOS.id = 'orgSectionDiv';
    const divBranch = U.divAtt('div', 'id', 'divBranch');
    const divisionDD = await comp.select_v2({elID: 'companyDD', ddData: this.divisionsData, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsTab.showCompanyBranchPlus()', initValue: this.userDetails.division_uuid});
    gridOE.appendChild(divisionDD);
    gridOE.appendChild(divBranch);
    grid1.appendChild(gridOE);
    grid1.appendChild(gridOS);
    this.showCompanyBranchPlus();
  },

  async showCompanyBranchPlus() {
    const companyDD = U.id('companyDD').value;
    const grid1 = U.id('divBranch');
    grid1.innerHTML = '';
    const grid2 = U.id('orgSectionDiv');
    grid2.innerHTML = '';

    if (!companyDD) {
      return;
    }

    const orgDiv = U.divAtt('div', 'id', 'orgDiv');

    const filteredData = this.divBranchesData.filter((division) => division.division_uuid === companyDD);

    const compBranchDD = await comp.select_v2({elID: 'compBranchDD', ddData: filteredData, valueDataName: 'division_branch_uuid', textDataName: 'short_text', labelName: 'Employee company branch', requiredYN: 1, onchange: 'thsTab.showOrg()'});
    grid1.appendChild(compBranchDD);
    grid1.appendChild(orgDiv);
  },

  async showOrg() {
    const compBranchDD = U.id('compBranchDD').value;
    const grid1 = U.id('orgSectionDiv');
    grid1.innerHTML = '';

    if (!compBranchDD) {
      return;
    }

    const orgBranchDiv = U.divAtt('div', 'id', 'orgBranchDiv');

    const filteredData = this.orgBranchesData.filter((org) => org.division_branch_uuid === compBranchDD);
    const orgDD = await comp.select_v2({elID: 'orgDD', ddData: filteredData, valueDataName: 'org_uuid', textDataName: 'short_text', labelName: 'Organisation', requiredYN: 1, onchange: 'thsTab.showOrgBranches()'});

    grid1.appendChild(orgDD);
    grid1.appendChild(orgBranchDiv);
  },

  async showOrgBranches() {
    const orgDD = U.id('orgDD').value;
    const grid1 = U.id('orgBranchDiv');
    grid1.innerHTML = '';

    if (!orgDD) {
      return;
    }

    const filteredData = this.orgBranchesData.filter((org) => org.org_uuid === orgDD);
    const orgBranchDD = await comp.select_v2({elID: 'orgBranchDD', ddData: filteredData, valueDataName: 'org_branch_uuid', textDataName: 'short_text', labelName: 'Organisation branch', requiredYN: 1, onchange: 'thsTab.buildSupportSection()'});

    grid1.appendChild(orgBranchDD);
  },

  async buildAdvisorSection() {
    const grid1 = U.id('advisorDiv');
    grid1.innerHTML = '';

    if (this.userDetails.role_uuid === ASSOCIATE_ADVISOR_ROLE_UUID) {
      await this.buildAdvisorAutosuggestBlock(grid1);
      return;
    }

    const associateAdvisors = Array.isArray(this.userDetails.associate_advisors) ? this.userDetails.associate_advisors : [];
    if (associateAdvisors.length > 0) {
      const assocWrap = U.divAtt('div', 'class', 'w-full');
      // Contain the global `table { mb-3 }` + avoid margin-collapse into Marketer: pad wrapper, no table bottom margin
      assocWrap.style.paddingBottom = '2rem';
      const assocHeading = U.divAtt('h6', 'class', 'mt-3 mb-2');
      assocHeading.textContent = 'Associated advisors';
      assocWrap.appendChild(assocHeading);

      const table = document.createElement('table');
      // Override global _table.scss `mb-3` so spacing is controlled on assocWrap only
      table.className = 'w-full text-sm !mb-0';
      table.style.setProperty('margin-bottom', '0', 'important');
      // Gutter fake borders must match `bg-primary` on thead (_table.scss / tailwind `colors.primary`)
      const headerRowBg = '#3B71CA';
      const bodyGutter = '5px';
      // Collapsed borders: 5px “gutters” via borders (avoids cell-bg gaps; thead color from global `thead` rule)
      table.style.borderCollapse = 'collapse';
      table.style.borderSpacing = '0';
      const thead = document.createElement('thead');
      const headRow = thead.insertRow();
      ['First name', 'Surname', 'Email', 'Broker number'].forEach((text, thIdx) => {
        const th = document.createElement('th');
        th.textContent = text;
        th.style.textAlign = 'left';
        th.style.padding = '0.5rem 0.75rem';
        th.style.backgroundColor = 'transparent';
        th.style.color = '#ffffff';
        th.style.borderBottom = '1px solid rgba(255,255,255,0.25)';
        th.style.fontWeight = '700';
        if (thIdx > 0) {
          th.style.borderLeft = `solid ${headerRowBg}`;
          th.style.borderLeftWidth = bodyGutter;
        }
        headRow.appendChild(th);
      });
      table.appendChild(thead);

      const cellText = (v) => {
        if (v == null) return '—';
        const s = String(v).trim();
        return s === '' ? '—' : s;
      };

      const tbody = document.createElement('tbody');
      const bodyCellGutter = bodyGutter;
      const bodyGutterColor = '#ffffff';
      associateAdvisors.forEach((row) => {
        const tr = tbody.insertRow();
        tr.style.borderBottom = '1px solid rgba(0,0,0,0.08)';
        [cellText(row.f_name), cellText(row.s_name), cellText(row.email_address), cellText(row.broker_number)].forEach((text, tdIdx) => {
          const td = tr.insertCell();
          td.textContent = text;
          td.style.padding = '0.4rem 0.75rem';
          td.style.verticalAlign = 'middle';
          if (tdIdx > 0) {
            td.style.borderLeft = `solid ${bodyGutterColor}`;
            td.style.borderLeftWidth = bodyCellGutter;
          }
        });
      });
      table.appendChild(tbody);
      assocWrap.appendChild(table);
      grid1.appendChild(assocWrap);
    }

    const gridA1 = U.divAtt('div', 'class', 'res-grid-cols-3');
    const marketerDD = await comp.select_v2({elID: 'marketerDD', ddData: this.marketersData, valueDataName: 'marketer_uuid', textDataName: 'long_text', labelName: 'Marketer', requiredYN: 1, initValue: this.userDetails.marketer_uuid});

    if (!this.userDetails.org_branch_uuid) {
      const warningText = document.createElement('span');
      warningText.className = 'text-warning ml-2';
      warningText.innerHTML = 'This user needs to be allocated to an organisation before a marketer can be chosen';
      marketerDD.querySelector('label').appendChild(warningText);
    } else if (!this.marketersData || !Array.isArray(this.marketersData) || this.marketersData.length === 0) {
      const warningText = document.createElement('span');
      warningText.className = 'text-warning ml-2';
      warningText.innerHTML = 'A marketer has not been allocated to the Division branch';
      marketerDD.querySelector('label').appendChild(warningText);
    }

    gridA1.appendChild(marketerDD);
    grid1.appendChild(gridA1);
  },

  /**
   * Same pattern as AddApplication.buildAdvisorSearch: communal/advisor-autosuggest + results table with radios.
   */
  async buildAdvisorAutosuggestBlock(parentEl) {
    const wrapOuter = U.divAtt('div', 'class', 'mt-3');
    wrapOuter.style.display = 'block';
    wrapOuter.style.border = 'none';
    wrapOuter.style.outline = 'none';
    wrapOuter.style.backgroundColor = 'transparent';
    wrapOuter.style.padding = '0';
    wrapOuter.style.margin = '0';

    const sectionHeading = U.divAtt('h6', 'class', 'mt-0 mb-2 flex flex-wrap items-baseline gap-x-3 gap-y-1');
    const titlePart = document.createElement('span');
    titlePart.textContent = 'Link to principle advisor';
    sectionHeading.appendChild(titlePart);
    const principleName = this.userDetails.principle_advisor_name;
    if (principleName != null && String(principleName).trim() !== '') {
      const currentPart = document.createElement('span');
      currentPart.className = 'font-normal text-grey-dark';
      currentPart.textContent = `Currently ${String(principleName).trim()}`;
      sectionHeading.appendChild(currentPart);
    }
    wrapOuter.appendChild(sectionHeading);

    const table = document.createElement('table');
    table.style.width = 'auto';
    table.style.marginTop = '0.5rem';
    table.style.borderCollapse = 'collapse';
    table.style.border = 'none';
    table.style.borderSpacing = '0';
    table.style.backgroundColor = 'transparent';

    const row1 = document.createElement('tr');

    const labelCell1 = document.createElement('td');
    labelCell1.style.paddingRight = '1rem';
    labelCell1.style.textAlign = 'right';
    labelCell1.style.verticalAlign = 'middle';
    labelCell1.style.border = 'none';
    labelCell1.innerHTML = '<label>Search advisor</label>';

    const inputCell1 = document.createElement('td');
    inputCell1.style.verticalAlign = 'middle';
    inputCell1.style.border = 'none';

    const searchInput = await comp.inputText('profileAdvisorSearch', '', '', 0, null, '');
    const searchInputDiv = searchInput.querySelector('#profileAdvisorSearchDiv');
    if (searchInputDiv) {
      const label = searchInputDiv.querySelector('label');
      if (label) label.remove();
      searchInputDiv.style.border = 'none';
      searchInputDiv.style.outline = 'none';
      searchInputDiv.style.boxShadow = 'none';
      searchInputDiv.style.backgroundColor = 'transparent';
      searchInputDiv.style.padding = '0';
    }
    const searchInputField = searchInput.querySelector('#profileAdvisorSearch');
    if (searchInputField) {
      searchInputField.style.width = '200px';
      searchInputField.style.maxLength = '20';
      searchInputField.removeAttribute('placeholder');
      searchInputField.addEventListener('input', () => {
        this.searchAdvisorsUserProfile();
      });
    }
    inputCell1.appendChild(searchInput);

    row1.appendChild(labelCell1);
    row1.appendChild(inputCell1);

    const row2 = document.createElement('tr');

    const labelCell2 = document.createElement('td');
    labelCell2.style.paddingRight = '1rem';
    labelCell2.style.textAlign = 'right';
    labelCell2.style.verticalAlign = 'top';
    labelCell2.style.paddingTop = '1rem';
    labelCell2.style.border = 'none';
    labelCell2.innerHTML = '<label>Select advisor</label>';

    const dropdownCell2 = document.createElement('td');
    dropdownCell2.style.verticalAlign = 'top';
    dropdownCell2.style.paddingTop = '1rem';
    dropdownCell2.style.border = 'none';
    dropdownCell2.style.maxWidth = 'min(100%, 1200px)';

    const advisorDropdownContainer = document.createElement('div');
    advisorDropdownContainer.id = 'profileAdvisorDropdownContainer';
    advisorDropdownContainer.style.display = 'none';
    advisorDropdownContainer.style.border = 'none';
    advisorDropdownContainer.style.outline = 'none';
    advisorDropdownContainer.style.backgroundColor = 'transparent';
    dropdownCell2.appendChild(advisorDropdownContainer);

    const advisorHidden = document.createElement('input');
    advisorHidden.type = 'hidden';
    advisorHidden.id = 'profileAdvisor';
    advisorHidden.name = 'profileAdvisor';
    advisorHidden.value = this.userDetails.advisor_uuid || '';
    dropdownCell2.appendChild(advisorHidden);
    const advisorFb = document.createElement('span');
    advisorFb.setAttribute('fb-for', 'profileAdvisor');
    dropdownCell2.appendChild(advisorFb);

    row2.appendChild(labelCell2);
    row2.appendChild(dropdownCell2);

    const tbody = document.createElement('tbody');
    tbody.style.border = 'none';
    tbody.appendChild(row1);
    tbody.appendChild(row2);
    table.appendChild(tbody);

    wrapOuter.appendChild(table);
    parentEl.appendChild(wrapOuter);

    this.profileAdvisorSearchTimeout = null;
    this.profileAdvisorSearchResults = [];
  },

  async searchAdvisorsUserProfile() {
    const searchInput = U.id('profileAdvisorSearch');
    if (!searchInput) return;

    const searchValue = searchInput.value.trim();

    if (this.profileAdvisorSearchTimeout) {
      clearTimeout(this.profileAdvisorSearchTimeout);
    }

    if (searchValue.length < 3) {
      const dropdownContainer = U.id('profileAdvisorDropdownContainer');
      const advisorHidden = U.id('profileAdvisor');
      if (advisorHidden) advisorHidden.value = this.userDetails.advisor_uuid || '';
      if (dropdownContainer) {
        dropdownContainer.style.display = 'none';
        dropdownContainer.innerHTML = '';
      }
      return;
    }

    this.profileAdvisorSearchTimeout = setTimeout(async () => {
      try {
        const inputEl = U.id('profileAdvisorSearch');
        const filter = inputEl ? inputEl.value.trim() : '';
        if (filter.length < 3) return;

        const {value: user_uuid} = await O.getCookie('ewttgpvwwkf');

        const vars = {};
        vars.search_filter = filter;
        vars.user_uuid = user_uuid;

        O.PREP([await O.mPOST('communal/advisor-autosuggest', vars)])
          .then(async (res) => {
            const advisorResults = res['communal/advisor-autosuggest'].data;

            if (advisorResults && advisorResults.length > 0) {
              this.profileAdvisorSearchResults = advisorResults;

              const dropdownContainer = U.id('profileAdvisorDropdownContainer');
              if (!dropdownContainer) return;
              dropdownContainer.innerHTML = '';

              const advisorHidden = U.id('profileAdvisor');
              const prevAdvisorUuid = advisorHidden && advisorHidden.value;
              if (advisorHidden) advisorHidden.value = '';

              const wrap = document.createElement('div');
              wrap.style.overflowX = 'auto';
              wrap.style.maxWidth = '100%';

              const tbl = document.createElement('table');
              tbl.style.borderCollapse = 'collapse';
              tbl.style.width = '100%';
              tbl.style.fontSize = '0.875rem';

              const thead = document.createElement('thead');
              const headRow = document.createElement('tr');
              const headerLabels = [
                '',
                'Associate advisor',
                'Advisor',
                'Broker number',
                'Division',
                'Division branch',
                'Organisation',
                'Organisation branch'
              ];
              headerLabels.forEach((label, hi) => {
                const th = document.createElement('th');
                th.textContent = label;
                th.style.textAlign = 'left';
                th.style.padding = '0.5rem 0.75rem';
                th.style.borderBottom = '1px solid rgba(0,0,0,0.15)';
                if (hi === 0) th.style.width = '2.5rem';
                headRow.appendChild(th);
              });
              thead.appendChild(headRow);
              tbl.appendChild(thead);

              const tbodyEl = document.createElement('tbody');
              const cellText = (v) => {
                if (v == null) return '—';
                const s = String(v).trim();
                return s === '' ? '—' : s;
              };

              advisorResults.forEach((row, idx) => {
                const tr = document.createElement('tr');
                tr.style.borderBottom = '1px solid rgba(0,0,0,0.08)';

                const tdRadio = document.createElement('td');
                tdRadio.style.padding = '0.35rem 0.75rem';
                tdRadio.style.verticalAlign = 'middle';
                const radio = document.createElement('input');
                radio.type = 'radio';
                radio.name = 'profileAdvisorRadio';
                radio.value = row.user_uuid;
                radio.id = `profileAdvisorRadio_${idx}`;
                radio.addEventListener('change', () => {
                  const hid = U.id('profileAdvisor');
                  if (hid) hid.value = row.user_uuid;
                });
                tdRadio.appendChild(radio);
                tr.appendChild(tdRadio);

                [
                  cellText(row.associate_text),
                  cellText(row.combo_text),
                  cellText(row.broker_number),
                  cellText(row.divisionname),
                  cellText(row.divisionbranchname),
                  cellText(row.organistionname),
                  cellText(row.organistionbranchname)
                ].forEach((text) => {
                  const td = document.createElement('td');
                  td.textContent = text;
                  td.style.padding = '0.35rem 0.35rem 0.35rem 0.75rem';
                  td.style.verticalAlign = 'middle';
                  tr.appendChild(td);
                });

                tbodyEl.appendChild(tr);
              });
              tbl.appendChild(tbodyEl);
              wrap.appendChild(tbl);
              dropdownContainer.appendChild(wrap);
              dropdownContainer.style.display = 'block';

              const uuidToMatch = prevAdvisorUuid || this.userDetails.advisor_uuid;
              if (uuidToMatch && advisorHidden) {
                const matchIdx = advisorResults.findIndex((r) => r.user_uuid === uuidToMatch);
                if (matchIdx >= 0) {
                  const rad = document.getElementById(`profileAdvisorRadio_${matchIdx}`);
                  if (rad) {
                    rad.checked = true;
                    advisorHidden.value = uuidToMatch;
                  }
                }
              }
            } else {
              const dropdownContainer = U.id('profileAdvisorDropdownContainer');
              const advisorHidden = U.id('profileAdvisor');
              if (advisorHidden) advisorHidden.value = this.userDetails.advisor_uuid || '';
              if (dropdownContainer) {
                dropdownContainer.style.display = 'none';
                dropdownContainer.innerHTML = '';
              }
            }
          })
          .catch(() => {});
      } catch (err) {
        // ignore
      }
    }, 1000);
  },

  async buildSupportSection() {
    const grid1 = U.id('supportDiv');
    grid1.innerHTML = '';
    // const roleSelect = U.id('roleSelect');
    if (this.userDetails.role_text !== 'Support') {
      return;
    }

    const orgBranchDD = U.id('orgBranchDD').value;

    if (!orgBranchDD) {
      return;
    }
    // ================================================
    // ADVISOR
    const advisorHeading = U.divAtt('h6', 'class', 'mt-3');
    grid1.appendChild(advisorHeading);

    const gridA1 = U.divAtt('div', 'class', 'res-grid-cols-3');
    const filteredData = this.advisorList.filter((advisor) => advisor.org_branch_uuid === orgBranchDD);
    const advisorDD = await comp.select_v2({elID: 'advisorDD', ddData: filteredData, valueDataName: 'user_uuid', textDataName: 'c_name', labelName: 'Advisor', requiredYN: 1});

    gridA1.appendChild(advisorDD);
    grid1.appendChild(gridA1);
  },

  async configForm(role_text) {
    switch (role_text) {
      case 'Marketer':
        await this.buildMainPage({pdfWillOnly: 0});
        // await this.buildCompanySection();
        break;
      case 'Admin':
        await this.buildMainPage({pdfWillOnly: 1});
        // await this.buildCompanySection();
        break;
      case 'Advisor':
      case 'Associate Advisor':
        await this.buildMainPage({pdfWillOnly: 0});
        // await this.buildCompanySectionPlus();
        await this.buildAdvisorSection();
        break;
      case 'Support':
        await this.buildMainPage({pdfWillOnly: 0});
        // await this.buildCompanySectionPlus();
        break;
      case 'Business development':
        await this.buildMainPage({pdfWillOnly: 0});
        break;
      default:
        const newUser = U.id('newUser');
        if (newUser) newUser.innerHTML = '';
    }
  },

  async addUser() {
    if (!(await U.validateForm('user-form'))) {
      return;
    }

    const vars = {};

    const roleSelect = U.id('roleSelect');

    const role_text = this.userDetails.role_text;

    // Office Details
    // vars.role = U.id('roleSelect').value;
    vars.role = this.userDetails.role_uuid;
    vars.target_user_uuid = this.target_user_uuid;
    vars.active = U.id('activeYN').checked;
    vars.pdfWillOnly = U.id('pdfWillOnly').checked;
    vars.autofillIdYn = U.id('autofillIdYn').checked;

    // Personal Details - REQUIRED
    vars.title_uuid = U.id('title').value;
    vars.fullName = U.id('f_name').value;
    vars.surname = U.id('s_name').value;
    vars.idNumber = U.id('IDpass_toggle').checked ? U.id('IDpass').value : null;
    vars.ppNumber = U.id('IDpass_toggle').checked ? null : U.id('IDpass').value;

    vars.email = U.id('email_address').value;
    vars.mobile = U.id('cell_nr').value;
    // vars.userpass = U.id('newPassword1').value;
    vars.notes = U.id('textarea').value;

    switch (role_text) {
      // case 'Marketer':
      //   vars.company = U.id('companyDD') ? U.id('companyDD').value : null;
      //   vars.employeeCompanyBranch = U.id('compBranchDD') ? U.id('compBranchDD').value : null;
      //   break;
      // case 'Admin':
      //   vars.company = U.id('companyDD') ? U.id('companyDD').value : null;
      //   vars.employeeCompanyBranch = U.id('compBranchDD') ? U.id('compBranchDD').value : null;
      //   break;
      case 'Advisor':
      case 'Associate Advisor':
        // vars.orgBranch = U.id('orgBranchDD').value;
        vars.brokerNumber = U.id('brokerNumber').value;
        if (this.userDetails.role_uuid === ASSOCIATE_ADVISOR_ROLE_UUID) {
          const profileAdv = U.id('profileAdvisor');
          const raw = profileAdv ? profileAdv.value.trim() : '';
          if (raw && raw.toLowerCase() !== NIL_UUID.toLowerCase()) {
            vars.principle_user_uuid = raw;
          }
        } else {
          vars.marketer = U.id('marketerDD').value;
        }
        break;
      // case 'Support':
      //   vars.advisor_uuid = U.id('advisorDD').value;
      //   break;
    }

    O.PREP([await O.mPOST('users/upd-user', vars)])
      .then(async (res) => {
        const msg = res['users/upd-user'].status;
        comp.toast(msg);
        const {value: loggedInUuid} = await O.getCookie('ewttgpvwwkf');
        if (loggedInUuid && this.target_user_uuid === loggedInUuid) {
          await O.createCookie('hflidautyn', U.id('autofillIdYn').checked);
          await O.hydrateUserSession();
        }
      })
      .catch(() => {});
  },

  async updatePassword() {
    const newPassword1 = U.id('newPassword1').value;
    const newPassword2 = U.id('newPassword2').value;

    // Min 8 char, 1 upper, 1 lower, one special
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

    if (newPassword1 === newPassword2) {
      if (!regex.test(newPassword1)) {
        return comp.toast_v2({msg: 'Please choose a stronger password', state: 2});
      }

      let vars = {};
      vars = {
        ...vars,
        target_user_uuid: this.target_user_uuid,
        userpass: U.id('newPassword1').value,
      };

      O.PREP([await O.mPOST('login/update-passwordtwo', vars)])
        .then(async (res) => {
          const msg = res['login/update-passwordtwo'].status;
          comp.toast(msg);
          U.closeModal('passBox');
        })
        .catch(() => {});
    } else {
      comp.toast_v2({msg: 'Passwords are not the same.', state: 2});
    }
  },

  onActiveYNToggle() {
    this._previousActiveYN = !U.id('activeYN').checked;
    const isActive = U.id('activeYN').checked;
    const heading = 'Change user active status';
    const msg = isActive
      ? 'Are you sure you want to set this user to Active?'
      : 'Are you sure you want to set this user to Inactive?';
    const proceedOnclick = 'thsTab.confirmToggleUserActive()';
    const cancelOnclick = 'thsTab.revertActiveYNToggle()';
    comp.modal(heading, msg, proceedOnclick, cancelOnclick);
  },

  revertActiveYNToggle() {
    if (this._previousActiveYN !== undefined) {
      U.id('activeYN').checked = this._previousActiveYN;
    }
  },

  async confirmToggleUserActive() {
    const vars = {
      activeyn: U.id('activeYN').checked,
      target_user_uuid: this.target_user_uuid,
    };
    O.PREP([await O.mPOST('users/toggle-user-active', vars)])
      .then(async (res) => {
        const msg = res['users/toggle-user-active'].status;
        comp.toast(msg);
        this.userDetails.active_yn = vars.activeyn;
      })
      .catch(() => {
        thsTab.revertActiveYNToggle();
      });
  },
};
